// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gOjMG","buttons":"styles_buttons__iFHgj"};